import React from 'react';
import { Award, RefreshCw } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import SponsorCard from './SponsorCard';

const GRID_STYLE = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
  gap: '1rem',
};

const SponsorsList = ({ loading, sponsors, filtered, onEdit, onDelete }) => (
  <Card className="table-card">
    <CardHeader>
      <CardTitle>Sponsors</CardTitle>
    </CardHeader>
    <CardContent>
      {(() => {
        if (loading) {
          return (
            <div className="loading-state">
              <RefreshCw className="animate-spin" size={32} />
              <p>Loading sponsors...</p>
            </div>
          );
        }
        if (filtered.length === 0) {
          const isEmpty = sponsors.length === 0;
          return (
            <div className="empty-state">
              <Award size={48} />
              <h3>{isEmpty ? 'No Sponsors Yet' : 'No matches'}</h3>
              <p>
                {isEmpty
                  ? 'Click "Add Sponsor" to get started.'
                  : 'Try a different search or tier filter.'}
              </p>
            </div>
          );
        }
        return (
          <div style={GRID_STYLE} data-testid="sponsor-grid">
            {filtered.map((s) => (
              <SponsorCard key={s.id} sponsor={s} onEdit={onEdit} onDelete={onDelete} />
            ))}
          </div>
        );
      })()}
    </CardContent>
  </Card>
);

export default SponsorsList;
